import React from 'react'
import { CompanyCredentials } from '@shared/components/company-credentials'

import { data } from './data'

import styles from './styles.module.scss'

export const View = () => {
	return (
		<article className={styles.tab}>
			<h2 className={styles.heading}>{data.heading}</h2>

			<p className={`${styles.content} ${styles.firstContent}`}>{data.firstContent}</p>

			<p className={`${styles.content} ${styles.secondContent}`}>{data.listHeading}</p>
			<ol className={styles.list}>
				{data.list.map((el) => (
					<li className={styles.listItem} key={el}>
						{el}
					</li>
				))}
			</ol>
			<p className={`${styles.content} ${styles.thirdContent}`}>{data.secondContent}</p>

			<div className={styles.telegram}>
				<p>
					Познакомьтесь с нашими продуктами в{' '}
					<a
						href='https://t.me/assistantccbot'
						target='_blank'
						rel='noopener noreferrer nofollow'
						className={styles.telegramLink}
					>
						умном чат-боте
					</a>{' '}
					или вступайте{' '}
					<a
						href='https://t.me/invest_creditclub'
						target='_blank'
						rel='noopener noreferrer nofollow'
						className={styles.telegramLink}
					>
						в чат инвесторов.
					</a>
				</p>
			</div>

			<div className={styles.credWrapper}>
				<CompanyCredentials
					ooo='КПК «Фонд Ипотечного Кредитования»'
					startYear='2019'
					inn='6678102434'
					withoutReestr
				/>
			</div>

			<p className={`${styles.content} ${styles.fourthContent}`}>
				Клиенты Credit.Club получили возможность зарабатывать на инвестициях с повышенной
				надёжностью: деньги направляются в займы, которые обеспечены залогом ликвидной недвижимости.
				При этом весь процесс автоматизирован — и для нашего клиента он такой же простой, как
				сделать обычный банковский вклад.
			</p>
		</article>
	)
}
